import React, { useState, useEffect } from "react";
import Button2 from "../Buttons/Button2/Button2";
import { API_BASE_URL } from "../../utils/apiConfig";
import Modal from "../Modal/Modal";

const ServicesCard = ({ servIcon, heading, content }) => {
  const [svgContent, setSvgContent] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    budget: "",
    projectType: heading || "", // auto-filled
    message: ""
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);

  const custSvg = `${API_BASE_URL}/getsvg/${servIcon}`;

  useEffect(() => {
    if (!custSvg) return;
    fetch(custSvg)
      .then(res => res.text())
      .then(setSvgContent)
      .catch(err => console.error("Failed to load SVG:", err));
  }, [custSvg]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setSuccess(null);

  try {
    // format message
    const sendMes = `Name: ${formData.name}
Email: ${formData.email}
Phone: ${formData.phone}
Project Type: ${formData.projectType}
Project Budget: ${formData.budget}
Message: ${formData.message}`;

    // request payload
    const sendData = {
      email: formData.email,   // or you can put your company email here as "to"
      message: sendMes
    };

    const res = await fetch(`${API_BASE_URL}/sendmail/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(sendData)
    });

    if (!res.ok) throw new Error("Failed to send message");

    setSuccess("✅ Your enquiry has been sent successfully!");
    setFormData({
      name: "",
      email: "",
      phone: "",
      budget: "",
      projectType: heading || "",
      message: ""
    });

    // auto-hide Modal
      setTimeout(() => setSuccess(false), 3000);
      
      setTimeout(() => setShowModal(false), 4000);
    // setShowModal(false)
  } catch (err) {
    setSuccess("❌ Something went wrong, please try again.");
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="card">
      <div className="card-content">
        {svgContent ? (
          <div
            className="icon"
            dangerouslySetInnerHTML={{ __html: svgContent }}
          />
        ) : (
          <div className="icon-placeholder">Loading...</div>
        )}
        <h2>{heading}</h2>
        <p>{content}</p>
        <Button2 text="Know more" onClick={() => setShowModal(true)} />

        {/* Full Page Modal */}
        <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
          <h2>Enquire about {heading}</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Your Phone Number"
              value={formData.phone}
              onChange={handleChange}
              pattern="[0-9]{10,15}" // basic phone validation
              required
            />
            <input
              type="text"
              name="budget"
              placeholder="Estimated Budget"
              value={formData.budget}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="projectType"
              value={formData.projectType}
              readOnly
            />
            <textarea
              name="message"
              placeholder="Tell us about your project..."
              value={formData.message}
              onChange={handleChange}
            />
            <button type="submit" disabled={loading}>
              {loading ? "Submitting..." : "Submit Enquiry"}
            </button>
          </form>
          {success && <p className="status">{success}</p>}
        </Modal>
      </div>
    </div>
  );
};

export default ServicesCard;
